import React from 'react';

export default function SectionIcon({ color = 'gray', size = 28, children, style, inverted = false }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: inverted ? 'var(--bg-surface)' : `var(--sec-${color})`,
        color: inverted ? `var(--sec-${color})` : '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
